//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Following Event Type GUIDS. */
export const FollowingEventType = {
    /** Gets the Baptisms GUID. */
    Baptisms: "694D5110-EFF0-4E53-818F-A8AFEA268584",
    /** Gets the Began Serving GUID. */
    BeganServing: "8F1476AD-CF60-4253-AC10-2094C6863D96",
    /** Gets the Birthdays GUID. */
    Birthdays: "F3A577DB-8F4A-4245-BD00-0B2B8F789131",
    /** Gets the Joined Small Group GUID. */
    JoinedSmallGroup: "CDFB247B-B868-49BD-A080-0B2E8679DA4C",
    /** Gets the Pastoral Note Added GUID. */
    PastoralNoteAdded: "E9CAED55-BFCE-4484-B5CC-23F563B84D68",
    /** Gets the Prayer Requests GUID. */
    PrayerRequests: "0323D1DE-616B-4060-AF72-1F17FEEA648F",
    /** Gets the Upcoming Anniversaries GUID. */
    UpcomingAnniversaries: "5E81D053-974F-4841-A829-58410356F080",
    /** Gets the Upcoming Birthdays GUID. */
    UpcomingBirthdays: "E1C2F8BD-E875-4C7B-91A1-EDB98AB01BDC",
};
